import { IFarmPlayerState } from './IFarmPlayerState';

export const initialFarmPlayerState: IFarmPlayerState = {
    slots: {
        house_0: { itemId: 'house_usa' },
    },
    unlockedAreas: ['area_0'],
};
